import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { getThemeColorScheme, getSidekickTheme } from "@avenue-8/sidekick-ui";
import { useAuthStore } from "@store/auth.store";

type Props = {
  children: React.ReactNode;
  defaultTheme?: "dark" | "light" | "system";
};

export const ThemeProvider = ({ children, defaultTheme }: Props) => {
  const { theme } = useAuthStore((state) => state.preferences);
  const colorScheme = getThemeColorScheme(defaultTheme ?? theme);
  const { emotionTheme, muiTheme } = getSidekickTheme({ colorScheme, v2: true });

  return (
    <StyledEngineProvider injectFirst>
      <EmotionThemeProvider theme={emotionTheme}>
        <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
      </EmotionThemeProvider>
    </StyledEngineProvider>
  );
};
